"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InvoicePartner {
    constructor(id, name, billingContact, masterPolicyId, commissionPercentage, serviceFeeLabel) {
        this.id = id;
        this.name = name;
        this.billingContact = billingContact;
        this.masterPolicyId = masterPolicyId;
        this.commissionPercentage = commissionPercentage;
        this.serviceFeeLabel = serviceFeeLabel !== null && serviceFeeLabel !== void 0 ? serviceFeeLabel : "Service Fee";
    }
    static fromObj(data) {
        return new InvoicePartner(data.id, data.name, data.billingContact, data.masterPolicyId, data.commissionPercentage, data.serviceFeeLabel);
    }
}
exports.default = InvoicePartner;
//# sourceMappingURL=invoicePartner.class.js.map